import type { Guide } from "./guide";

/** Guide 9: vestra mcp in your editor, and /v1/mcp from anywhere. Its code is the editor's config: the agent does the calling. */
export const YOUR_EDITOR: Guide = {
  slug: "your-editor",
  samples: "editor",
  title: "Work from your editor",
  nav: "From your editor",
  summary:
    "Set Bash up, test it and ask it from your editor's chat: vestra mcp on your computer, or /v1/mcp from anywhere.",
  minutes: 5,
  lede: "Your editor's agent can set Bash up, test it and ask it for you. Add `vestra mcp` to your editor once, then ask in plain words.",
  lines: ["mcp", "init", "test"],
  steps: [
    {
      id: "login",
      title: "Log in once",
      body: [
        "In a terminal, run `vestra login` with your test key ([quickstart](/developers/quickstart)).",
      ],
      then: "Your key is saved on this computer, and `vestra mcp` uses it.",
    },
    {
      id: "add",
      title: "Add it to your editor",
      body: [
        "A stdio server: the command `vestra`, with the argument `mcp`. Cursor and Windsurf take this file as it is.",
      ],
      file: "mcp.json",
      then: "Your editor starts `vestra mcp` itself, and its agent sees Vestra's tools: `init`, `test`, `deploy`, `ask` and the rest.",
    },
    {
      id: "vscode",
      title: "Or in VS Code",
      body: [
        "VS Code reads `.vscode/mcp.json`, where the list is `servers` and each says its `type`.",
      ],
      file: "mcp-vscode.json",
      fileAs: ".vscode/mcp.json",
      then: "The same tools, in VS Code's agent.",
    },
    {
      id: "setup",
      title: "Set Bash up by talking",
      body: [
        "Ask your editor's agent: \"Set up Vestra to answer Tripnest travellers' booking questions.\"",
      ],
      then: "It calls `init`, brings you Bash's questions, and writes `vestra.yaml` into your folder.",
    },
    {
      id: "test",
      title: "Test it",
      body: ['Ask: "Run the tests."'],
      then: "It calls `test`, waits up to 45 seconds for the verdict, and reads you the reason for any failure.",
    },
    {
      id: "deploy",
      title: "Ship it to test mode",
      body: ['Ask: "Deploy it."'],
      then: "`deploy` runs on your computer with your key, and only ever to test mode. Going live is yours to type: `vestra deploy --live`.",
    },
    {
      id: "ask",
      title: "Ask it",
      body: [
        'Ask as a traveller would: "Ask travel-help, as traveller-42, when my flight on TN-48213 leaves."',
      ],
      then: "It calls `ask`. An approval is asked right in your editor, when your editor supports it.",
    },
    {
      id: "remote",
      title: "Or connect from anywhere",
      body: [
        'Any MCP client can reach `/v1/mcp` with your key as a Bearer token: while in preview, on `api-staging.vestra.ai` ([`mcp`](/developers/mcp)). Cursor takes this file as it is; in VS Code, list it under `servers` with `"type": "http"`.',
      ],
      file: "mcp-remote.json",
      fileAs: "mcp.json",
      then: "The same tools, except `deploy`: shipping a version stays with you.",
    },
  ],
};
